export default __webpack_public_path__ + "static/media/icon-reversed-fleche-blanc.95b46a37.svg";